export const AI_INSPECTION_URL_TIME_LIMIT = 30 * 1000;

export const executeWithTimeLimit = (action, timeLimit) => {
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error('Time limit exceeded'));
    }, timeLimit);
  });

  return Promise.race([action, timeoutPromise]);
};




// WEBPACK FOOTER //
// ./src/timeLimit.js